import React from 'react';
import { PopupContext } from 'ui-builder';
import ChatHeader from './Components/ChatHeader';
import MessageList from './Components/MessageList';
import MessageInput from './Components/MessageInput';
import { useHeightResize } from './useHeightResize';
import { useWidthResize } from './useWidthResize';
import { useAutoContext } from '../useAutoContext';
import styles from './ChatWidget.module.scss';

interface ChatWidgetLayoutProps {
  onClose: () => void;
  onExpand: (conversationId: number | null) => void;
}

export default function ChatWidgetLayoutWeb(props: ChatWidgetLayoutProps) {
  useAutoContext();

  const { height, handleRef, panelRef } = useHeightResize({
    minHeight: 300,
    maxHeightVh: 95,
    initialHeightRem: 50,
  });

  const { width, widthHandleRef } = useWidthResize();

  return (
    <PopupContext>
      <div
        className={styles.panel}
        ref={panelRef}
        style={{ height, width }}
        data-testid="chat-widget"
      >
        <div className={styles.resizeHandleLeft} ref={widthHandleRef} />
        <div className={styles.resizeHandle} ref={handleRef} />
        <ChatHeader onClose={props.onClose} onExpand={props.onExpand} />
        <MessageList />
        <MessageInput />
      </div>
    </PopupContext>
  );
}
